/**
 * @fileoverview Module that creates a set of radio inputs and allows a user to filter them
 *
 * @author Nicholas Cassleman (ncassleman@yext.com)
 */
goog.module('yext.ui.RadioFilter');
goog.module.declareLegacyNamespace();

/**
 * Converts a div into a grouping of radio input elements
 *
 * There are two states of the module. The first state is pre-rendered, wherein
 * instantiating the module will initialize the event listeners immediately. The
 * second is an unloaded state, wherein the elements are loaded via AJAX and the
 * event listeners are set up after the AJAX request is completed. If the container
 * has the attribute data-ajax-url, it assumes the unloaded state and will use
 * the value of that attribute in its AJAX request
 *
 * @constructor
 * @param {!jQuery} $container The jQuery object representing the container
 */
const RadioFilter = function($container) {
  this.$container = undefined; // the container holding the search bar and items
  this.$items = undefined; // the container holding the radio button input elements
  this.$labels = undefined; // the container holding the labels containing radio buttons
  this.$searchBox = undefined; // the search box input element
  this.keyupTimer = undefined; // the timer that triggers filtering when expired

  this.$container = $container;

  if (this.$container.data('ajaxUrl')) {
    this.loadItems(this.$container.data('ajaxUrl'));
  } else {
    this.initialize();
  }
};
goog.exportSymbol('yext.ui.RadioFilter', RadioFilter);

/**
 * Initializes properties on the module
 */
RadioFilter.prototype.initialize = function() {
  this.$items = this.$container.find('.js-radiofilter-iteminput');
  this.$labels = this.$container.find('.js-radiofilter-itemlabel');
  this.$searchBox = this.$container.find('.js-radiofilter-searchinput');

  if (this.$searchBox.data('searchable')) {
    this.bindSearchBoxFiltering();
  }
};

/**
 * Binds event listeners for RadioFilter
 */
RadioFilter.prototype.bindSearchBoxFiltering = function() {
  var self = this;

  // search box filtering when the user has entered text and paused for a moment
  this.$container.on('keyup', '.js-radiofilter-searchinput', function() {
    clearTimeout(self.keyupTimer);

    self.keyupTimer = setTimeout(function() {
      self.filterItems(self.$searchBox.val());
    }, 200);
  });
};

/**
 * Filters items to display only those with the provided string
 *
 * @param {string} str String to filter on (case insensitive)
 */
RadioFilter.prototype.filterItems = function(str) {
  var regex = new RegExp(str, 'i');
  var firstItem = true;

  this.$labels.filter('.first-item').removeClass('first-item');

  this.$items.each(function(index, item) {
    var $item = $(item);
    var $label = $item.closest('.js-radiofilter-itemlabel');
    var shouldDisplay = regex.test($item.data('searchText'));

    $label.toggle(shouldDisplay);

    if (firstItem && shouldDisplay) {
      $label.addClass('first-item');
      firstItem = false;
    }
  });
};

/**
 * Loads items via AJAX and inserts them into the DOM
 *
 * @param {string} url Endpoint that will return the HTML
 */
RadioFilter.prototype.loadItems = function(url) {
  var self = this;

  $.ajax({
    url: url,
    dataType: 'html',
    type: 'GET',
    success: function(data) {
      self.$container.html(data);
      self.initialize();
    },
    error: function() {
      self.$container.text(yext.msg('There was an error processing your request.'));
    },
  });
};

exports = RadioFilter;
